import React from 'react';


import {ACCESS_RIGHTS} from 'src/hooks/access-rights/constants';
import {useAdminAccessRight} from 'src/hooks/access-rights/useAdminAccessRight';
import {PermissionDenied} from 'src/modules/error-page';

import Loading from '@pb/kit-component-loading';

type Props = {
    children: React.ReactElement,
};

export const Authorization: React.FC<Props> = ({children}) => {
    const {hasAccess, isLoading} = useAdminAccessRight();

    if (isLoading) {
        return <Loading fast={true}/>;
    }

    return hasAccess(ACCESS_RIGHTS.PB_ADMIN_2_ACCESS) ? children : <PermissionDenied/>;
};
